import { StyledTaskActivityNav } from '@/shared/TaskActivityDetail/TaskActivityNav/TaskActivityNav.styled';
import isCurrentTaskActivity from '@/modules/tasks/isCurrentTaskActivity';
import TaskActivityNavLink from '@/shared/TaskActivityDetail/TaskActivityNav/TaskActivityNavLink/TaskActivityNavLink';

export default function PreviewTaskActivityNav({
  taskActivities,
  currentTaskActivityId,
  currentActivityId,
  currentMiniactivityType,
  dueDate,
  onSelectTaskActivity,
}) {
  return (
    <StyledTaskActivityNav>
      <div className="task-activity-links">
        {taskActivities?.map((taskActivity, index) => {
          return (
            <TaskActivityNavLink
              key={index}
              taskActivity={taskActivity}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onSelectTaskActivity(taskActivity);
              }}
              isCurrent={isCurrentTaskActivity(
                taskActivity,
                currentTaskActivityId,
                currentActivityId,
                currentMiniactivityType
              )}
              feedbackParams={{
                dueDate,
                timeOffset: null,
              }}
            />
          );
        })}
      </div>
    </StyledTaskActivityNav>
  );
}
